module.exports = __webpack_public_path__ + "img/fr.f3f1ae18.png";